import styled from 'styled-components';

export const Divider = styled.div`
    border-top: 0.2rem solid ${({ theme: { colors } }) => colors.white};
`;
